import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { CreditInfo, StoreProfile } from '../models';
import { API_BASE_URL } from '../tokens/api-base-url.token';

/** Fallback profile — no `/api/profile` endpoint is wired up yet. */
const DEFAULT_STORE_PROFILE: StoreProfile = {
  storeName: 'Zenoms',
  storeCode: 'TEP-KRM-014',
  gstin: '29AABCT1332L1ZP',
  shipsFrom: 'Hosur warehouse',
  support: '1800 266 0123',
  gstRate: 18,
  lowStockThreshold: 10,
  showDealerPrice: true,
};

/** Store profile + credit line. Swap the mock return for the http call. */
@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);
  private readonly endpoint = `${this.baseUrl}/api/profile`;

  getProfile(): Observable<StoreProfile> {
    // return this.http.get<StoreProfile>(this.endpoint);
    return of(structuredClone(DEFAULT_STORE_PROFILE)).pipe(delay(300));
  }

  /** Live credit line for the signed-in store. `locationId` = the store id from login. */
  getCreditInfo(locationId: string): Observable<CreditInfo> {
    return this.http.get<CreditInfo>(
      `${this.baseUrl}/api/sok/oms/creditInfo/locationId/${locationId}`,
    );
  }
}
